import { createStructuredSelector } from 'reselect';
import { userDataSelector } from '@selectors/global';
import {
  arbitratorLookupModalOpenSelector,
  arbitratorLookupModalModeSelector,
  arbitratorLookupModalStateSelector,
  arbitratorLookupModalDataSelector,
  arbitratorLookupModalRecordCountSelector,
  fieldsSelector,
} from '@modules/litigation/selectors/arbitrator';
import { preferenceSelector } from '@modules/appraisal/selectors/global';

export default createStructuredSelector({
  fields: fieldsSelector,
  modalOpen: arbitratorLookupModalOpenSelector,
  mode: arbitratorLookupModalModeSelector,
  state: arbitratorLookupModalStateSelector,
  data: arbitratorLookupModalDataSelector,
  recordCount: arbitratorLookupModalRecordCountSelector,
  preference: preferenceSelector,
  userData: userDataSelector,
});
